<template>
  <div class="sidebar-age-badge" role="note" :aria-label="ariaLabel">
    <div class="sidebar-age-badge__mark" aria-hidden="true">
      <span class="sidebar-age-badge__num">19</span>
      <span class="sidebar-age-badge__plus">+</span>
    </div>
    <div class="sidebar-age-badge__body">
      <strong class="sidebar-age-badge__title">{{ $t('sidebar.ageRestrictionTitle') }}</strong>
      <p class="sidebar-age-badge__desc">{{ $t('sidebar.ageRestrictionDesc') }}</p>
    </div>
    <div class="sidebar-age-badge__rim" aria-hidden="true" />
  </div>
</template>

<script>
export default {
  name: 'BlackGoldAgeRestriction',
  computed: {
    ariaLabel () {
      return `${this.$t('sidebar.ageRestrictionTitle')}. ${this.$t('sidebar.ageRestrictionDesc')}`
    }
  }
}
</script>
